import { Box, styled } from '@mui/material';
import { APPROVAL_SECTION_GAP } from '@/components/Approval/@components/InfoSection';

export const MortgageFeeRoot = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${APPROVAL_SECTION_GAP}px;
`;

export const FixedText = styled('p')`
  margin: 0;
  padding: 12px;
  border: 1px solid var(--dk-line, #e7e9ec);
  font-size: 14px;
  line-height: 20px;
  color: var(--dk-text, #1a1a1a);
`;

export const NoteList = styled('ul')`
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 14px;
  line-height: 20px;
  color: var(--dk-text, #1a1a1a);
`;

/** 제목 줄 오른쪽에 단위 — 제목·표 간격을 단위 없는 섹션과 같게 */
export const SectionHeader = styled(Box)`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;

  & > p {
    flex-shrink: 0;
    white-space: nowrap;
  }
`;
